/* eslint-disable spaced-comment */
/* eslint-disable prefer-template */
/* eslint-disable consistent-return */


const gcd = (a, b) => {
    while (b !== 0) {
        const temp = b;
      b = a % b;
      a = temp;
    }
    return a;
  };
  
  
const helper = {
    /**
     * MM & DD -> return double digit date parts (with 0 prefix) if less then 10.
     * M & D -> return single digit date parts if less then 10.
     * mm -> minutes.
     * ss -> seconds.
     * fff -> milliseconds.
     */
    formatDate: (date, format) => {
        try {
            
            if (!date) {
                return '';
            }
            let req_date = date;
            if (typeof date == 'string') {
                if (date.toString().indexOf('/Date(') === 0) {
                    var matches = date.match(/\(([^)]+)\)/);
                    if (matches && matches.length > 1 && parseInt(matches[1], 10) > 0) {
                        req_date = new Date(parseInt(matches[1], 10));
                    }
                } else {
                    req_date = new Date(date);
                }
            }
            const month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            const month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const map = {
                HH: ('0' + req_date.getHours()).slice(-2),
                mm: ('0' + req_date.getMinutes()).slice(-2),
                ss: ('0' + req_date.getSeconds()).slice(-2),
                fff: ('00' + req_date.getMilliseconds()).slice(-3),
                M: req_date.getMonth() + 1,
                MM: ('0' + (req_date.getMonth() + 1)).slice(-2),
                MMM: month_names_short[req_date.getMonth()],
                MMMM: month_names[req_date.getMonth()],
                D: req_date.getDate(),
                DD: ('0' + req_date.getDate()).slice(-2),
                YY: req_date.getFullYear().toString().slice(-2),
                YYYY: req_date.getFullYear()
            };

            const result = format.replace(/HH|mm|ss|fff|MMMM|MMM|MM|M|DD|D|YYYY|YY/g, (matched) => map[matched]);
            return result;
        } catch (error) {
            console.log(error);
            // logger.info(createLogMessage(stack(), error));
        }
    },
    formatShortDateRange(from, to) {
        try { const d1 = from.getDate();
        const m1 = from.getMonth() + 1;
        const y1 = from.getFullYear() % 100;
      
        const d2 = to.getDate();
        const m2 = to.getMonth() + 1;
        const y2 = to.getFullYear() % 100;
      
        if (y1 === y2 && m1 === m2) {
          return `${d1}–${d2}/${m1}/${y1}`;
        } 
        if (y1 === y2) {
          return `${d1}/${m1}–${d2}/${m2}/${y1}`;
        } 
        
          return `${d1}/${m1}/${y1}–${d2}/${m2}/${y2}`;

        } catch (e){
            console.log('formatShortDateRange', e,from,to);
            return '';
        }
       
        
      },
    stringToDate_byFormat: (date, format) => {
        try {

            if (!date) {
                return null;
            }
            const hours_indx = format.indexOf('HH');
            const minutes_indx = format.indexOf('mm');
            const dd_indx = format.indexOf('DD');
            const mm_indx = format.indexOf('MM');
            const yyyy_indx = format.indexOf('YYYY');
            
            const hours = hours_indx >= 0 ? parseInt(date.slice(hours_indx,hours_indx + 2),10) : 0;
            const minutes = minutes_indx >= 0 ? parseInt(date.slice(minutes_indx,minutes_indx + 2),10) : 0;

            const dd = dd_indx >= 0 ? parseInt(date.slice(dd_indx,dd_indx + 2),10) : 0;
            const mm = mm_indx >= 0 ? parseInt(date.slice(mm_indx, mm_indx + 2),10) - 1 : 0;
           const yyyy = yyyy_indx >= 0 ? parseInt(date.slice(yyyy_indx,yyyy_indx + 4),10) : 0;
           
            const new_date = new Date(); // yyyy,mm,dd,hours,minutes
            new_date.setHours(0, 0, 0, 0); // reset time
            new_date.setDate(1); // default
            if(yyyy){
            new_date.setFullYear(yyyy);}
            if(mm || mm == 0) { new_date.setMonth(mm);}
            if(dd) { new_date.setDate(dd); }
            if(!isNaN(hours)) { new_date.setHours(hours); }
            if(!isNaN(minutes)) { new_date.setMinutes(minutes);}
            return new_date;
        } catch (error) {
           // console.log(error);
            // logger.info(createLogMessage(stack(), error));
        }
    },
    checkDateRengesOverlap: (a_start, a_end, b_start, b_end, inclusive) => {
        
        let aStart = helper.stringToDate_byFormat(a_start,'DD/MM/YYYY');
        let aEnd = helper.stringToDate_byFormat(a_end,'DD/MM/YYYY');
        let bStart = helper.stringToDate_byFormat(b_start,'DD/MM/YYYY');
        let bEnd = helper.stringToDate_byFormat(b_end,'DD/MM/YYYY');
        // Optionally normalize if inputs might be reversed:
        if (aStart > aEnd) [aStart, aEnd] = [aEnd, aStart];
        if (bStart > bEnd) [bStart, bEnd] = [bEnd, bStart];
        if(inclusive){
            return aStart <= bEnd && bStart <= aEnd;
        }
        // exclusive
        return aStart < bEnd && bStart < aEnd;
        
      },
    periodToMonthAndYear: (period) => {
        let req_year = new Date().getFullYear();
        let req_month = new Date().getMonth();

        let prev_year = new Date().getFullYear();
        let prev_month = new Date().getMonth();
        //"3" > מתחילת החודש
        //"4" > חודש קודם

        if (period === '3') {
            const req_d = new Date();
            req_year = req_d.getFullYear();
            req_month = req_d.getMonth() + 1;

            const prev_d = new Date();
            prev_d.setMonth(prev_d.getMonth() - 1);
            prev_d.setDate(1);
            prev_year = prev_d.getFullYear();
            prev_month = prev_d.getMonth() + 1;
        } else if (period === '4') {
            const req_d = new Date();
            req_d.setMonth(req_d.getMonth() - 1);
            req_d.setDate(1);
            req_year = req_d.getFullYear();
            req_month = req_d.getMonth() + 1;

            const prev_d = new Date();
            prev_d.setMonth(prev_d.getMonth() - 2);
            prev_d.setDate(1);
            prev_year = prev_d.getFullYear();
            prev_month = prev_d.getMonth() + 1;
        }

        return {
            req_year,
            req_month,
            prev_year,
            prev_month
        };
    },
    periodToDateRange: (period) => {
        const from_date = new Date();
        const to_date = new Date();

        //"1" > היום
        //"2" > אתמול
        //"3" > מתחילת החודש
        //"4" > חודש קודם
        if (period === '1') {
            from_date.setUTCHours(0, 0, 0, 0);

            to_date.setUTCHours(23, 59, 59, 999);
        } else if (period === '2') {
            from_date.setDate(from_date.getDate() - 1);
            from_date.setUTCHours(0, 0, 0, 0);

            to_date.setDate(to_date.getDate() - 1);
            to_date.setUTCHours(23, 59, 59, 999);
        } else if (period === '3') {
            from_date.setDate(1);
            from_date.setUTCHours(0, 0, 0, 0);

            to_date.setDate(0); //set to last day of previous month
            to_date.setMonth(to_date.getMonth() + 1);
            to_date.setUTCHours(23, 59, 59, 999);
        } else if (period === '4') {
            from_date.setMonth(from_date.getMonth() - 1);
            from_date.setDate(1);
            from_date.setUTCHours(0, 0, 0, 0);

            to_date.setDate(0); //set to last day of previous month
            to_date.setUTCHours(23, 59, 59, 999);
        }

        return {
            from_date,
            to_date
        };
    },
    numberWithCommas: (x, decimal_places, default_result) => {
        if (decimal_places == null) {
            decimal_places = 2;
        }
        
        if (x != undefined && typeof x == 'string'){
            x = x.replaceAll(',','');
            if(decimal_places > 0){
                x = parseFloat(x)
            }else{
            x = parseInt(x,10);
            }
        }
        if (x == null || isNaN(x)) {
            if (default_result !== undefined) {
                return default_result;
            }
            return '0';
        }
        
        var factor = Math.pow(10, decimal_places);
        x = Math.round((x + Number.EPSILON) * factor) / factor;
        var t1 = x.toFixed(decimal_places);
        var t2 =(t1 * 1).toString(); // remove not needed 0
        var t3 = t2.split('.'); // separate by decimal
        // var t2 = t1.replace(/\.00$/, '');
        var t4 = t3[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (t3[1] ? '.' + t3[1] : '');

        return t4;
    },
    parseDateString: (dateString) => {
        /**
         * "Date(123456789123)" to date object
         */
        var matches = dateString.match(/\(([^)]+)\)/);
        if (matches && matches.length > 1 && parseInt(matches[1], 10) > 0) {
            const date = new Date(parseInt(matches[1], 10));
            return date;
        }

        return dateString;
    },
    formatDateRange: (fromDate, toDate,from_label,to_label) => {
    const getDate = (value) => {
        if (!value) return null;

        const date = value instanceof Date ? value : new Date(value);
        return isNaN(date.getTime()) ? null : date;
    };

    const format = (date, includeYear) => {
        if (includeYear === undefined) includeYear = true;

        const d = date.getDate();
        const m = date.getMonth() + 1;
        const y = date.getFullYear();

        return includeYear ? d + '/' + m + '/' + y : d + '/' + m;
    };

    const from = getDate(fromDate);
    const to = getDate(toDate);

    if (!from && !to) return '';
    if (from && !to) return from_label + ' ' + format(from);
    if (!from && to) return to_label + ' ' + format(to);

    const sameYear = from.getFullYear() === to.getFullYear();
    const sameMonth = sameYear && from.getMonth() === to.getMonth();

    if (sameMonth) {
        return from.getDate() + '-' + format(to);
    }

    if (sameYear) {
        return format(from, false) + '-' + format(to);
    }

    return format(from) + '-' + format(to);
},
    getLocalDateTime: (date) => {
        const ms = date.valueOf();
        const offset = date.getTimezoneOffset();
        return new Date(ms + offset * 60000);
    },
    getNumeric: (string) => {
        const num = string != null ? parseInt(string, 10) : -1;
        if (isNaN(num)) {
            return -1;
        }
        return num;
    },
    getNumeric: (string,default_result) => {
        const num = string != null ? parseInt(string, 10) : -1;
        if (isNaN(num)) {
            return default_result;
        }
        return num;
    },
    getIneger: (string) => {
        const num = string != null ? parseInt(string, 10) : -1;
        if (isNaN(num)) {
            return -1;
        }
        return num;
    },
    getDecimal: (string) => {
        const num = string != null ? parseFloat(string, 10) : -1;
        if (isNaN(num)) {
            return -1;
        }
        return num;
    },
    getDecimal: (string,default_result) => {
        const num = string != null ? parseFloat(string, 10) : default_result;
        if (isNaN(num)) {
            return default_result;
        }
        return num;
    },
    formatFileSize: (size, decimal_place) => {
        if(!size){
            return '';
        }
        const sizes = ["B", "KB", "MB", "GB", "TB"];
        let len = size;
        let order = 0;
        while (len >= 1024 && order < sizes.length - 1) {
            order += 1;
            len /= 1024;
        }

        // Adjust the format string to your preferences. For example "{0:0.#}{1}" would
        // show a single decimal place, and no space.
        const result = len.toFixed(decimal_place || 0) + sizes[order];
        return result;
    },
    isInteger:(string) => {
        if(/^\d+$/.test(string)){
            return true;
        }
        return false;
    },
    isDecimal:(string) => {
        if(/^-?\d+(\.\d+)?$/.test(string)){
            return true;
        }
        return false;
    },
    getCurrencySign:(currency) =>
    {
        if (currency == 1)
        {
            return "$";
        }
        
        if (currency == 2)
        {
            return "₪";
        }
        if (currency == 3)
            return '€';
        return '';
    },
    calculateExpr: (expr1) => {
       const brackets = expr1.match(/\(([^)]+)\)/);
       if(brackets && brackets.length > 0){
        const inner_expr = brackets[1];
        if(inner_expr){
            const inner_expr_result = helper.calculateExpr(inner_expr);
            expr1 = expr1.replaceAll('(' + inner_expr + ')', inner_expr_result);
        }
       }
      
        let temp_expr = expr1;
        const chars = expr1.split("");
        const n = [];
        const op = [];
        let index = 0;
        let oplast = true;
    
        n[index] = "";
    
        // Parse the expression
        for (let c = 0; c < chars.length; c+=1) {
    
            if (isNaN(parseInt(chars[c],10)) && chars[c] !== "." && !oplast) {
                op[index] = chars[c];
                index+=1;
                n[index] = "";
                oplast = true;
            } else {
                n[index] += chars[c];
                oplast = false;
            }
        }
    
        // Calculate the expression
        temp_expr = parseFloat(n[0]);
        for (let o = 0; o < op.length; o+=1) {
            const num = parseFloat(n[o + 1]);
            switch (op[o]) {
                case "+":
                    temp_expr += num;
                    break;
                case "-":
                    temp_expr -= num;
                    break;
                case "*":
                    temp_expr *= num;
                    break;
                case "/":
                    if(num == 0){
                        temp_expr = 0;
                    }else{
                        temp_expr /= num;
                    }
                    break;
            }
        }
    
        return temp_expr;
    },
    getAspectRatioLabel: (width, height) => {
        const divisor = gcd(width, height);  // Get the greatest common divisor
        const simplifiedWidth = width / divisor;
        const simplifiedHeight = height / divisor;
        return `${simplifiedWidth}:${simplifiedHeight}`;
      },
    regExp: {
        email: new RegExp(/^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/u),
        phone: new RegExp(/^\d{6,12}$/),
        url: new RegExp(/\bhttps?:\/\/(?:www\.)?[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:/~+#]*[\w@?^=%&/~+#])?/),
        material_num: new RegExp(/^[A-Za-z0-9][A-Za-z0-9_-]{2,31}$/),
        international_phone: new RegExp(/^\+[1-9]{1}[0-9]{3,14}$/)


    },
    copyToClipboardAsync: async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.warn("Modern API failed, falling back to execCommand", err);
        
            // Fallback for older browsers
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed"; // Prevent scrolling to bottom of page
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
        
            let success = false;
            try {
                success = document.execCommand("copy");
                
                console.log(success ? "Copied with fallback" : "Fallback copy failed");
            } catch (fallbackErr) {
                
                console.error("Fallback copy failed", fallbackErr);
            }
        
            document.body.removeChild(textarea);
            return success;
        }
    },
    downloadTagFile: (filename, text) => {
        var element = document.createElement('a');
        element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
        element.setAttribute('download', filename);
        
        element.style.display = 'none';
        document.body.appendChild(element);
        
        element.click();
        
        document.body.removeChild(element);
    },
    
    safeUUID: () => {
        // Prefer native when available
        if (typeof this !== "undefined") {
          const c = this.crypto;
          if (c && typeof c.randomUUID === "function") return c.randomUUID();
          if (c && typeof c.getRandomValues === "function") {
            // RFC4122-ish v4 using getRandomValues
            const bytes = new Uint8Array(16);
            c.getRandomValues(bytes);
            bytes[6] = (bytes[6] && 0x0f) || 0x40; // version 4
            bytes[8] = (bytes[8] && 0x3f) || 0x80; // variant 10
      
            const hex = Array.prototype.map.call(bytes, (b) =>
              b.toString(16).padStart(2, "0")
            ).join("");
      
            return (
              hex.slice(0, 8) + "-" +
              hex.slice(8, 12) + "-" +
              hex.slice(12, 16) + "-" +
              hex.slice(16, 20) + "-" +
              hex.slice(20)
            );
          }
        }
      
        // Last-resort fallback (not cryptographically strong)
        return "id-" + Date.now().toString(16) + "-" + Math.random().toString(16).slice(2);
      },
    hexToRgba: (hex, opacity) => {
        const normalized = hex.replace('#', '');
          const fullHex = normalized.length === 3
              ? normalized.split('').map((c) => c + c).join('')
              : normalized;
      
          const r = parseInt(fullHex.substring(0, 2), 16);
          const g = parseInt(fullHex.substring(2, 4), 16);
          const b = parseInt(fullHex.substring(4, 6), 16);
      
        return `rgba(${r},${g},${b},${opacity})`;
      },
      getEnumValue: (enumObj, value) => {
        const num = Number(value);

        if (!Number.isFinite(num)) {
            return undefined;
        }

        return Object.prototype.hasOwnProperty.call(enumObj, num)
            ? num
            : undefined;
    },
    isMonthPassed: (inputDate) => {
        if(inputDate) {
        const today = new Date();
  
        // Create Date objects for the start of both calendar months
        const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const inputMonthStart = new Date(inputDate.getFullYear(), inputDate.getMonth(), 1);
        
        // True if the input month starts before the current month
        return inputMonthStart < currentMonthStart;
        }
        return undefined;
    }
            
};


  

export default helper;
